import { CHANGE_LANG } from "../actions/LangActions";

const initialState = {
	lang: localStorage.getItem("Afkar_Lang") || "en",
};

export function LangReducer(state = initialState, action) {
	if (action.type === CHANGE_LANG) {
		return {
			lang: action.payload,
		};
	}
	return state;
}
